import { FuseDialog, FuseMessage, FuseScrollbars } from '@fuse';
import Loading from '@fuse/components/FuseLoadable/Loading';
import { withStyles } from '@material-ui/core';
import AppContext from 'app/AppContext';
import SettingsPanel from 'app/Configs/fuse-layouts/shared-components/SettingsPanel';
import CatchErro from 'app/Core/Components/CatchErro/CatchErro';
import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import { withRouter } from 'react-router-dom';
import FooterLayout1 from './components/FooterLayout1';
import LeftSideLayout1 from './components/LeftSideLayout1';
import NavbarWrapperLayout1 from './components/NavbarWrapperLayout1';
import RightSideLayout1 from './components/RightSideLayout1';
import ToolbarLayout1 from './components/ToolbarLayout1';

const styles = theme => ({
    root: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        '&.boxed': {
            maxWidth: 1280,
            margin: '0 auto',
            boxShadow: theme.shadows[3]
        },
        '&.scroll-body': {
            '& $wrapper': {
                height: 'auto',
                flex: '0 0 auto',
                overflow: 'auto'
            },
            '& $contentWrapper': {},
            '& $content': {}
        },
        '&.scroll-content': {
            '& $wrapper': {},
            '& $contentWrapper': {},
            '& $content': {}
        }
    },
    wrapper: {
        display: 'flex',
        position: 'relative',
        width: '100%',
        height: '100%',
        flex: '1 1 auto',
    },
    contentWrapper: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        zIndex: 3,
        overflow: 'hidden',
        flex: '1 1 auto'
    },
    content: {
        position: 'relative',
        display: 'flex',
        overflow: 'auto',
        flex: '1 1 auto',
        flexDirection: 'column',
        width: '100%',
        '-webkit-overflow-scrolling': 'touch',
        zIndex: 2
    },
    contentPreload: {
        position: 'relative',
        display: 'none',
        overflow: 'auto',
        flex: '1 1 auto',
        flexDirection: 'column',
        width: '100%',
        '-webkit-overflow-scrolling': 'touch',
        zIndex: 2
    }
});

const Layout1 = ({ classes, settings, children, xappRouteParams }) => {
    // console.warn('FuseLayout:: rendered');
    const layoutConfig = settings.layout.config;


    switch (layoutConfig.scroll) {
        case 'body':
            {
                return (
                    <AppContext.Consumer>
                        {({ routes }) => (

                            <div id="fuse-layout" className={classNames(classes.root, layoutConfig.mode, 'scroll-' + layoutConfig.scroll)}>

                                {layoutConfig.leftSidePanel.display && (
                                    <CatchErro>
                                        <LeftSideLayout1 />
                                    </CatchErro>
                                )}

                                <div className="flex flex-1 flex-col overflow-hidden relative">

                                    {layoutConfig.toolbar.display && layoutConfig.toolbar.style === 'fixed' && layoutConfig.toolbar.position === 'above' && (
                                        <CatchErro>
                                            <ToolbarLayout1
                                                xappRouteParams={xappRouteParams}
                                            />
                                        </CatchErro>
                                    )}

                                    <FuseScrollbars className="overflow-auto">

                                        {layoutConfig.toolbar.display && layoutConfig.toolbar.style !== 'fixed' && layoutConfig.toolbar.position === 'above' && (
                                            <CatchErro>
                                                <ToolbarLayout1
                                                    xappRouteParams={xappRouteParams}
                                                />
                                            </CatchErro>
                                        )}

                                        <div className={classes.wrapper}>

                                            {layoutConfig.navbar.display && layoutConfig.navbar.position === 'left' && (
                                                <CatchErro>
                                                    <NavbarWrapperLayout1 />
                                                </CatchErro>
                                            )}

                                            <div className={classes.contentWrapper}>

                                                {layoutConfig.toolbar.display && layoutConfig.toolbar.position === 'below' && (
                                                    <CatchErro>
                                                        <ToolbarLayout1
                                                            xappRouteParams={xappRouteParams}
                                                        />
                                                    </CatchErro>
                                                )}

                                                <div className={classes.content}>
                                                    <CatchErro>
                                                        <FuseDialog />
                                                    </CatchErro>
                                                    <CatchErro>
                                                        {renderRoutes(routes)}
                                                        {children}
                                                    </CatchErro>
                                                </div>

                                                {layoutConfig.footer.display && layoutConfig.footer.position === 'below' && (
                                                    <CatchErro>
                                                        <FooterLayout1
                                                            xappRouteParams={xappRouteParams}
                                                        />
                                                    </CatchErro>
                                                )}

                                                <SettingsPanel />

                                            </div>

                                            {layoutConfig.navbar.display && layoutConfig.navbar.position === 'right' && (
                                                <CatchErro>
                                                    <NavbarWrapperLayout1 />
                                                </CatchErro>
                                            )}
                                        </div>


                                        {layoutConfig.footer.display && layoutConfig.footer.style !== 'fixed' && layoutConfig.footer.position === 'above' && (
                                            <CatchErro>
                                                <FooterLayout1
                                                    xappRouteParams={xappRouteParams}
                                                />
                                            </CatchErro>
                                        )}

                                    </FuseScrollbars>

                                    {layoutConfig.footer.display && layoutConfig.footer.style === 'fixed' && layoutConfig.footer.position === 'above' && (
                                        <CatchErro>
                                            <FooterLayout1
                                                xappRouteParams={xappRouteParams}
                                            />
                                        </CatchErro>
                                    )}

                                </div>

                                {layoutConfig.rightSidePanel.display && (
                                    <CatchErro>
                                        <RightSideLayout1
                                            xappRouteParams={xappRouteParams}
                                        />
                                    </CatchErro>
                                )}
                                <CatchErro>
                                    <FuseMessage />
                                </CatchErro>
                            </div>
                        )}
                    </AppContext.Consumer>
                );
            }
        case 'content':
        default:
            {
                return (
                    <AppContext.Consumer>
                        {({ routes }) => (
                            <div id="fuse-layout" className={classNames(classes.root, layoutConfig.mode, 'scroll-' + layoutConfig.scroll)}>

                                {layoutConfig.leftSidePanel.display && (
                                    <CatchErro>
                                        <LeftSideLayout1 />
                                    </CatchErro>
                                )}

                                <div className="flex flex-1 flex-col overflow-hidden relative">

                                    {layoutConfig.toolbar.display && layoutConfig.toolbar.position === 'above' && (
                                        <CatchErro>
                                            <ToolbarLayout1
                                                xappRouteParams={xappRouteParams}
                                            />
                                        </CatchErro>
                                    )}

                                    <div className={classes.wrapper}>

                                        {layoutConfig.navbar.display && layoutConfig.navbar.position === 'left' && (
                                            <CatchErro>
                                                <NavbarWrapperLayout1 />
                                            </CatchErro>
                                        )}

                                        <div className={classes.contentWrapper}>
                                            {layoutConfig.toolbar.display && layoutConfig.toolbar.position === 'below' && layoutConfig.toolbar.style === 'fixed' && (
                                                <CatchErro>
                                                    <ToolbarLayout1
                                                        xappRouteParams={xappRouteParams}
                                                    />
                                                </CatchErro>
                                            )}
                                            <FuseScrollbars id="PreloadContainer" className={classes.contentPreload}>
                                                <Loading pastDelay={true} />
                                            </FuseScrollbars>
                                            <FuseScrollbars id="ContentContainer" className={classes.content}>
                                                {layoutConfig.toolbar.display && layoutConfig.toolbar.position === 'below' && layoutConfig.toolbar.style !== 'fixed' && (
                                                    <CatchErro>
                                                        <ToolbarLayout1
                                                            xappRouteParams={xappRouteParams}
                                                        />
                                                    </CatchErro>
                                                )}
                                                <CatchErro>
                                                    <FuseDialog />
                                                </CatchErro>

                                                <CatchErro>
                                                    {renderRoutes(routes)}
                                                    {children}
                                                </CatchErro>

                                                {layoutConfig.footer.display && layoutConfig.footer.position === 'below' && layoutConfig.footer.style !== 'fixed' && (
                                                    <CatchErro>
                                                        <FooterLayout1
                                                            xappRouteParams={xappRouteParams}
                                                        />
                                                    </CatchErro>
                                                )}
                                            </FuseScrollbars>

                                            {layoutConfig.footer.display && layoutConfig.footer.position === 'below' && layoutConfig.footer.style === 'fixed' && (
                                                <CatchErro>
                                                    <FooterLayout1
                                                        xappRouteParams={xappRouteParams}
                                                    />
                                                </CatchErro>
                                            )}

                                            {/*<SettingsPanel/>*/}

                                        </div>

                                        {layoutConfig.navbar.display && layoutConfig.navbar.position === 'right' && (
                                            <CatchErro>
                                                <NavbarWrapperLayout1 />
                                            </CatchErro>
                                        )}
                                    </div>


                                    {layoutConfig.footer.display && layoutConfig.footer.style === 'fixed' && layoutConfig.footer.position === 'above' && (
                                        <CatchErro>
                                            <FooterLayout1
                                                xappRouteParams={xappRouteParams}
                                            />
                                        </CatchErro>
                                    )}

                                </div>

                                {layoutConfig.rightSidePanel.display && (
                                    <CatchErro>
                                        <RightSideLayout1
                                            xappRouteParams={xappRouteParams}
                                        />
                                    </CatchErro>
                                )}
                                <CatchErro>
                                    <FuseMessage />
                                </CatchErro>
                            </div>
                        )}
                    </AppContext.Consumer>
                );
            }
    }
};

function mapStateToProps({ fuse }) {
    return {
        settings: fuse.settings.current,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps)(Layout1)));
